import registerAgentHandlers from "./agent";
import registerCallHandlers from "./call";
import registerHistoryHandlers from "./history";
import registerCaseHandlers from "./cases";
import registerCcpSessionHandlers from "./session";
import registerWebRTCHandlerEvents from "./webrtc";
import { registerPermissionCheckEvents } from "./permissionCheck";
import registerCcpInstanceHandlers from "./multiInstance";
import registerTelemetryEvents from "../telemetry";
import registerChatHandlerEvents from "./chat";
import registerCallbackHandlers from "./callback";
import registerVoicemailHandlers from "./voicemail";
import registerNotificationHandlers from "./notifications";

export default function registerEventHandlers() {
  registerWebRTCHandlerEvents();
  registerAgentHandlers();
  registerCallHandlers();
  registerChatHandlerEvents();
  registerHistoryHandlers();
  registerCaseHandlers();
  registerCcpSessionHandlers();
  registerPermissionCheckEvents();
  registerCcpInstanceHandlers();
  registerTelemetryEvents();
  registerCallbackHandlers();
  registerVoicemailHandlers();
  registerNotificationHandlers();
}
